// Copyright 2020
//   __  __                       _           _     _   _            _ _   _     
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__  
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \ 
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//                                                                              
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/sensor/v1/air_quality.proto (package msh.trait.sensor.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { CaptureMode } from "../../../common/v1/capture_mode_pb";

/**
 * @generated from message msh.trait.sensor.v1.AirQualityTrait
 */
export const AirQualityTrait = proto3.makeMessageType(
  "msh.trait.sensor.v1.AirQualityTrait",
  () => [
    { no: 1, name: "air_quality", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "air_quality_level", kind: "enum", T: proto3.getEnumType(AirQualityTrait_AirQualityLevel) },
  ],
);

/**
 * Based on BME680 spec sheet
 *
 * @generated from enum msh.trait.sensor.v1.AirQualityTrait.AirQualityLevel
 */
export const AirQualityTrait_AirQualityLevel = proto3.makeEnum(
  "msh.trait.sensor.v1.AirQualityTrait.AirQualityLevel",
  [
    {no: 0, name: "AIR_QUALITY_LEVEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "AIR_QUALITY_LEVEL_EXCELLENT", localName: "EXCELLENT"},
    {no: 2, name: "AIR_QUALITY_LEVEL_GOOD", localName: "GOOD"},
    {no: 3, name: "AIR_QUALITY_LEVEL_LIGHTLY_POLLUTED", localName: "LIGHTLY_POLLUTED"},
    {no: 4, name: "AIR_QUALITY_LEVEL_MODERATELY_POLLUTED", localName: "MODERATELY_POLLUTED"},
    {no: 5, name: "AIR_QUALITY_LEVEL_HEAVILY_POLLUTED", localName: "HEAVILY_POLLUTED"},
    {no: 6, name: "AIR_QUALITY_LEVEL_SEVERELY_POLLUTED", localName: "SEVERELY_POLLUTED"},
    {no: 7, name: "AIR_QUALITY_LEVEL_EXTREMELY_POLLUTED", localName: "EXTREMELY_POLLUTED"},
  ],
);

/**
 * @generated from message msh.trait.sensor.v1.AirQualityTrait.AirQualityChangedEvent
 */
export const AirQualityTrait_AirQualityChangedEvent = proto3.makeMessageType(
  "msh.trait.sensor.v1.AirQualityTrait.AirQualityChangedEvent",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "trait", kind: "message", T: AirQualityTrait },
    { no: 3, name: "capture_mode", kind: "enum", T: proto3.getEnumType(CaptureMode) },
  ],
  {localName: "AirQualityTrait_AirQualityChangedEvent"},
);

